import { logEvent } from 'firebase/analytics';
import { getFirebaseAnalytics } from '../firebase';

export const trackEvent = async (eventName, params = {}) => {
  try {
    const analytics = await getFirebaseAnalytics();
    if (analytics) {
      logEvent(analytics, eventName, params);
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Analytics event skipped:', eventName, error);
    }
  }
};

export const trackGameStart = (game) => {
  trackEvent('game_start', {
    game_id: game.id,
    game_name: game.name,
    category: game.category,
  });
};

export const trackGameRestart = (game) => {
  trackEvent('game_restart', {
    game_id: game.id,
    game_name: game.name,
  });
};

export const trackGameComplete = (game, details = {}) => {
  trackEvent('game_complete', {
    game_id: game.id,
    game_name: game.name,
    ...details,
  });
};

export const trackGameExit = (game) => {
  trackEvent('game_session_exit', {
    game_id: game.id,
    game_name: game.name,
  });
};

export const saveRecentlyPlayed = (game) => {
  try {
    const key = 'ideapetal_recent_games';
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    const next = [
      { id: game.id, slug: game.slug, name: game.name, playedAt: new Date().toISOString() },
      ...existing.filter((item) => item.id !== game.id),
    ].slice(0, 4);

    localStorage.setItem(key, JSON.stringify(next));
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Recently played could not be saved:', error);
    }
  }
};
